import React, { ChangeEvent, useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import styled from 'styled-components';

import { StyledFormControl } from '../styled/Inputs';
import { DeleteIcon, FieldCol } from '../styled/ContactsForm';
import { ThirdPartyIdObject } from './ThirdPartyIdFields';
import trash from '../../core/assets/trash.png';

import { TAppThirdPartyIdSource, } from 'TProtocol/common/models';

interface Props {
  thirdPartyId: ThirdPartyIdObject;
  onChange?: (thirdPartyId: ThirdPartyIdObject, value: string, fieldAttribute: 'source' | 'value') => void;
  onDelete: (thirdPartyId: ThirdPartyIdObject) => void;
}

export default function ThirdPartyIdField({ thirdPartyId, onChange, onDelete }: Props) {
  const [source, setSource] = useState<TAppThirdPartyIdSource | undefined>();
  const [value, setValue] = useState<string>('');
  const isDisabled = thirdPartyId.thirdPartyId?.provenances?.size ?? 0 > 0;

  useEffect(() => {
    if (thirdPartyId.thirdPartyId?.source) {
      setSource(thirdPartyId.thirdPartyId.source);
    }
    if (thirdPartyId.thirdPartyId?.value) {
      setValue(thirdPartyId.thirdPartyId.value);
    }
  }, [thirdPartyId.thirdPartyId]);

  const handleChange = (e: ChangeEvent<HTMLSelectElement | HTMLInputElement>, fieldAttribute: string) => {
    e.preventDefault();

    const value = e.target.value;
    if (fieldAttribute === 'source') {
      setSource(+value as TAppThirdPartyIdSource);
      onChange && onChange(thirdPartyId, value, 'source');
    } else if (fieldAttribute === 'value') {
      setValue(value);
      onChange && onChange(thirdPartyId, value, 'value');
    }
  };

  const handleDelete = () => {
    if (thirdPartyId.thirdPartyId) {
      onDelete(thirdPartyId);
    }
  };

  return (
    <Form.Group as={Row}>
      <FieldCol>
        <StyledFormControl
          value={value}
          onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange(e, 'value')}
          placeholder="Other social profile"
        />
      </FieldCol>

      <FieldCol>
        <PlatformDropdown
          className={source !== undefined ? '' : ' text-secondary'}
          value={source}
          disabled={isDisabled}
          onChange={(e: ChangeEvent<HTMLSelectElement>) => handleChange(e, 'source')}
        >
          <option value={undefined}>Platform</option>
          <option value={TAppThirdPartyIdSource.TWITTER}>Twitter</option>
          <option value={TAppThirdPartyIdSource.INSTAGRAM}>Instagram</option>
          <option value={TAppThirdPartyIdSource.FACEBOOK_MESSENGER}>Messenger</option>
          <option value={TAppThirdPartyIdSource.FACEBOOK}>Facebook</option>
          <option value={TAppThirdPartyIdSource.LINKEDIN}>LinkedIn</option>
          <option value={TAppThirdPartyIdSource.VENMO}>Venmo</option>
          <option value={TAppThirdPartyIdSource.URL}>Url</option>
          <option value={TAppThirdPartyIdSource.WHATSAPP}>WhatsApp</option>
          <option value={TAppThirdPartyIdSource.SNAPCHAT}>Snapchat</option>
          <option value={TAppThirdPartyIdSource.YELP}>Yelp</option>
        </PlatformDropdown>
      </FieldCol>
      <FieldCol xs={1}>
        <DeleteIcon src={trash} onClick={handleDelete}/>
      </FieldCol>
    </Form.Group>
  );

}

const PlatformDropdown = styled(Form.Select)`
  font-size: 14px;
  cursor: pointer;
  border: solid 1px #009bdf;
  padding: 0.5rem 2.25rem 0.5rem 1.5rem;
`;
